import gsap from 'gsap'

export const accordion = () => {

	let els = document.querySelectorAll('[data-accordion]')

	if (!els.length || window.innerWidth < 782) return

	els.forEach(el => {

		let originalHeight = el.offsetHeight

		el.style.height = originalHeight + 'px'

		el.addEventListener('toggle', () => {
			if (el.open) {
				let question = el.querySelector('.question'),
					answer = el.querySelector('.answer')
				el.style.height = question.offsetHeight + answer.offsetHeight + 'px'
			} else {
				el.style.height = originalHeight + 'px'
			}
		})
	})
}

export default () => { }